import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { withRouter } from 'react-router';

import PartnerBlockComponent from '../partner/PartnerBlockComponent';
import LogoPartenaireComponent from '../partner/LogoPartenaireComponent';
import {
    FormComponent,
    EmailInputFieldComponent,
    CheckboxInputFieldComponent,
    DateInputFieldComponent,
    FilesInputFieldComponent,
    NumberInputFieldComponent,
    RadioInputFieldComponent,
    PhoneInputFieldComponent,
    SelectFieldComponent,
    TextInputFieldComponent,
    TextareaFieldComponent,
    PasswordInputFieldComponent
} from '../form';
import LinkButtonComponent from '../button/LinkButtonComponent';
import ButtonComponent from '../button/ButtonComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';
import CarouselComponent from '../carousel/CarouselComponent';
import { withTemplate } from '../template/withTemplate';
import { PrimaryTemplate } from '../template/PrimaryTemplate';

import { IS_DEV } from '../../constants/index';
import HeadComponent from '../HeadComponent';
import Breadcrumb from '../breadcrumb/Breadcrumb';

class GuidelinesPage extends Component {
    componentWillMount() {
        if (!IS_DEV) {
            this.props.history.push('/404');
        }
    }
    render() {
        const partenaireDummy = {
            id: 91223,
            ebcId: 3831,
            moId: 377949,
            name: '1.2.3',
            url: 'http://track.effiliation.com/servlet/effi.click?id_compteur=20482203',
            creationDate: 1518598911,
            platformType: 'EFFILIATION',
            shortDescription:
                "1.2.3 est la référence de l'élégance féminine. Vous retrouverez une très large collection de produits : tailleurs, vestes, pantalons, robes, jupes ou encore des accessoires, qui habilleront toutes vos tenues. Chacun des modèles proposés, est réalisés dans des matières de très haute qualité. Pour un style raffiné, rendez-vous chez 1.2.3.",
            description:
                "1.2.3 est la référence de l'élégance féminine. Vous retrouverez une très large collection de produits : tailleurs, vestes, pantalons, robes, jupes ou encore des accessoires, qui habilleront toutes vos tenues. Chacun des modèles proposés, est réalisés dans des matières de très haute qualité. Pour un style raffiné, rendez-vous chez 1.2.3.",
            conditions: '',
            turnoverEbcOrder: 1000,
            validationDelay: 0,
            appearAverageDelay: 0,
            categoriesIds: [1648],
            couponCount: 0,
            mostDisplayableDiscountOnline: {
                fixed: 0,
                initialFixed: 0,
                percent: 7.7,
                initialPercent: 6.3
            },
            isMultiDiscount: true
        };

        const { dispatch } = this.props;

        return (
            <main role="main" className="conteneur">
                <HeadComponent title="Guidelines" description="Meta description" />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: 'Guidelines',
                            route: 'guidelines'
                        }
                    ]}
                />
                <h1>
                    Welcome to the guidelines page of the app
                    <br />
                    <small>This page showcase all reusable components in the app</small>
                </h1>
                <h3>Titles</h3>
                <div>
                    <h1>Ceci est un h1</h1>
                    <h2>Ceci est un h2</h2>
                    <h3>Ceci est un h3</h3>
                </div>
                <hr />
                <h3>Components from feature partenaire</h3>
                <div className="grid-4 has-gutter">
                    <div>
                        <h4>Bloc partenaire</h4>
                        <PartnerBlockComponent partner={partenaireDummy} />
                    </div>
                    <div>
                        <h4>Logo Partenaire</h4>
                        <LogoPartenaireComponent partenaire={partenaireDummy} />
                    </div>
                    <div>
                        <h4>Petit logo Partenaire</h4>
                        <LogoPartenaireComponent partenaire={partenaireDummy} small />
                    </div>
                </div>
                <hr />
                <h3>Buttons</h3>
                <div className="grid-4 has-gutter">
                    <LinkButtonComponent
                        to="http://google.com"
                        text="Ceci est un <a>"
                        title="Yo !"
                        color="main"
                    />
                    <ButtonComponent text="Ceci est un <button>" color="main" />
                </div>
                <hr />
                <div className="grid-4 has-gutter">
                    <ButtonComponent text="Ceci est un <button> transparent" color="main" />
                    <ButtonComponent text="Ceci est un <button> transparent" color="third" />
                    <ButtonComponent
                        text="Ceci est un <button> transparent avec bordure jaune"
                        color="fourth"
                    />
                </div>
                <hr />
                <h3>LocalizedNavLink</h3>
                <p>
                    Ceci est un <LocalizedNavLink to="www.google.com">lien</LocalizedNavLink> qui
                    est à utiliser pour tous vos liens.
                </p>
                <hr />
                <h3>Carrousel</h3>
                <CarouselComponent
                    options={{
                        infinite: true,
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }}>
                    <PartnerBlockComponent partner={partenaireDummy} />
                    <PartnerBlockComponent partner={partenaireDummy} />
                    <PartnerBlockComponent partner={partenaireDummy} />
                    <PartnerBlockComponent partner={partenaireDummy} />
                </CarouselComponent>
                <p>
                    Pour les options, voir{' '}
                    <a href="https://github.com/akiran/react-slick">la doc du plugin</a>
                </p>
                <hr />
                <h3>Formulaire</h3>
                <FormComponent
                    form="guidelines-form"
                    initialValues={{ nom: 'Jean Michel' }}
                    onSubmit={data => {
                        dispatch(reset('guidelines-form'));
                        alert('form submited !');
                    }}
                    errorSubmit={false}
                    requestSubmit={false}>
                    <EmailInputFieldComponent
                        name="email"
                        label="Adresse email"
                        placeholder="Votre adresse email"
                        isRequired
                    />
                    <TextInputFieldComponent name="nom" placeholder="votre nom" label="Nom" />
                    <PasswordInputFieldComponent name="motdepasse" label="Mot de passe" />
                    <DateInputFieldComponent name="date" label="Une date" mustBeDateFuture />
                    <NumberInputFieldComponent
                        name="nombre"
                        label="Un nombre"
                        max="10"
                        isRequired
                        hideErrorMessage
                    />
                    <PhoneInputFieldComponent name="telephone" label="Un numéro de téléphone" />
                    <RadioInputFieldComponent
                        name="civilite"
                        label="Civilité"
                        options={[
                            { label: 'Mme', value: 0 },
                            { label: 'Mr', value: 1 }
                        ]}
                        isRequired
                    />
                    <CheckboxInputFieldComponent
                        name="couleurs"
                        label="Couleurs"
                        options={[
                            { label: 'Bleu', value: 0 },
                            { label: 'Rouge', value: 1 }
                        ]}
                        minRequired="1"
                    />
                    <SelectFieldComponent
                        name="plats"
                        label="Plat préféré"
                        defaultOptionLabel="Faites votre choix"
                        isRequired
                        options={[
                            { label: 'Pot au feu', value: 0 },
                            { label: 'Lasagnes', value: 1 }
                        ]}
                    />
                    <TextareaFieldComponent name="message" label="Un petit mot" isRequired />
                    <FilesInputFieldComponent
                        name="piecesjointes"
                        btText="Choisissez un fichier"
                        formatAccepted={['html', 'pdf', 'jpg', 'jpeg', 'doc', 'png']}
                        maxSize={2}
                        multiple
                    />
                </FormComponent>
            </main>
        );
    }
}

export default withRouter(withTemplate(connect()(GuidelinesPage), PrimaryTemplate));



// WEBPACK FOOTER //
// ./src/components/pages/GuidelinesPage.js